<!-- USERS -->
<template>
    <v-row no-gutters class="fill-height">
        <!-- // * LEFT PANEL -->
        <v-col :cols="GET_panelLayout.leftPanel">
            <v-row class="px-2 mt-2 pa-0" dense>
                <!-- // * DESCRIPTION -->
                <v-col :cols="computedCols">
                    <v-row no-gutters class="">
                        <v-col class="px-2" cols="12" xs="6" sm="6" md="12">
                            <app-text category="content-title"
                                >{{ $t(`${langPath}.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text
                            >
                            <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.text`) }}</app-text>
                        </v-col>
                    </v-row>
                </v-col>
                <!-- // * FILTERS -->
                <v-col :cols="computedCols" class="px-2">
                    <v-row dense>
                        <v-col cols="12" xs="12" sm="12" md="4" class="">
                            <v-text-field
                                background-color="white"
                                v-model="search"
                                prepend-inner-icon="icons8-search"
                                filled
                                dense
                                :label="$t(`filters.search`)"
                                clearable
                                hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" class="" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-select
                                :menu-props="{ top: false, offsetY: true }"
                                :attach="true"
                                background-color="white"
                                v-model="filter.type"
                                :items="userTypes"
                                item-text="text"
                                item-value="value"
                                filled
                                dense
                                clearable
                                :label="$t(`filters.type`)"
                                hide-details
                            >
                                <template v-slot:item="data">{{ data.item.text }}</template>
                                <template v-slot:selection="data">{{ data.item.text }}</template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" class="" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-select
                                :menu-props="{ top: false, offsetY: true }"
                                :attach="true"
                                background-color="white"
                                v-model="filter.roles"
                                :items="userRoles"
                                item-text="text"
                                item-value="value"
                                filled
                                dense
                                clearable
                                :label="$t(`filters.roles`)"
                                hide-details
                            >
                                <template v-slot:item="data">{{ data.item.text }}</template>
                                <template v-slot:selection="data">{{ data.item.text }}</template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" class="" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-autocomplete
                                :disabled="GET_currentUser.userType === 'CONTRACTOR'"
                                :menu-props="{ top: false, offsetY: true }"
                                :attach="true"
                                autocomplete="donotautocomplete"
                                background-color="white"
                                v-model="filter.organisation"
                                filled
                                dense
                                :label="$t('filters.organisation')"
                                hide-details
                                auto-select-first
                                clearable
                                :items="organisations"
                                item-text="organisationName"
                                return-object
                            >
                                <template v-slot:item="data">
                                    {{ data.item.organisationName }}
                                    <!-- <span v-if="data.item.organisationStatus === 'PENDING'" class="warning--text font-weight-bold pl-1">(PENDING)</span> -->
                                    <!-- <span class="pl-1 font-weight-thin grey--text text--darken-1 caption">{{ data.item.organisationType }}</span> -->
                                </template>
                                <template v-slot:selection="data">
                                    {{ data.item.organisationName }}
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" class="" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-select
                                :menu-props="{ top: false, offsetY: true }"
                                :attach="true"
                                background-color="white"
                                v-model="filter.site"
                                :items="sites"
                                item-text="siteName"
                                return-object
                                filled
                                dense
                                clearable
                                :label="$t(`filters.lastSite`)"
                                hide-details
                            >
                                <template v-slot:item="data">{{ data.item.siteName }}</template>
                                <template v-slot:selection="data">{{ data.item.siteName }}</template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" class="d-flex align-center" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-select
                                :menu-props="{ top: false, offsetY: true }"
                                :attach="true"
                                background-color="white"
                                v-model="sortBy"
                                :items="filteredHeaders"
                                item-text="text"
                                item-value="value"
                                filled
                                clearable
                                dense
                                :label="$t(`filters.sortBy`)"
                                hide-details
                            >
                                <template v-slot:item="data">{{ $t(`fields.${data.item.text}`) }}</template>
                                <template v-slot:selection="data">{{ $t(`fields.${data.item.text}`) }}</template>
                            </v-select>
                            <v-btn icon class="ml-2" @click="filter.sortAsc = !filter.sortAsc"
                                ><v-icon :class="{ 'icons8-down-arrow': filter.sortAsc, 'icons8-up-arrow': !filter.sortAsc }" class="text-h5"></v-icon
                            ></v-btn>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" class="d-flex align-center " v-if="$vuetify.breakpoint.lgAndUp">
                            <v-checkbox
                                v-model="filter.complianceNotifications"
                                :label="$t('filters.complianceNotifications')"
                                hide-details
                                class="mt-0 pt-0"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                </v-col>
                <!-- 
            <v-row class="ma-0 mt-2 pa-0" no-gutters>
                <v-col cols="2" class="py-2 pl-4">
                    <v-text-field background-color="white" prepend-inner-icon="icons8-search" filled dense :label="$t('filters.search')" v-model="search" clearable hide-details></v-text-field>
                </v-col>
                <v-col cols="2" class="pl-2 py-2">
                    <v-select background-color="white" filled dense clearable :label="$t('filters.workType')" hide-details></v-select>
                </v-col>
                <v-col cols="2" class="pl-2 py-2">
                    <v-autocomplete background-color="white" v-model="filter.organisation" filled dense :label="$t('filters.organisation')" hide-details auto-select-first clearable :items="organisations" item-text="organisationName" return-object></v-autocomplete>
                </v-col>      
                <v-col cols="2" class="pl-2 py-2">
                    <v-autocomplete background-color="white" v-model="filter.projectManager" filled dense :label="$t('filters.managedBy')" hide-details auto-select-first clearable :items="ownerManagers" item-text="userName" return-object></v-autocomplete>
                </v-col>         
                <v-col cols="2" class="pl-2 py-2">
                    <v-autocomplete background-color="white" v-model="filter.site" filled dense :label="$t('filters.site')" hide-details auto-select-first clearable :items="sites" item-text="siteName" return-object></v-autocomplete>
                </v-col>                                     
                <v-col cols="2" class="pl-2 pr-4 py-2">
                    <v-select background-color="white" v-model="sortBy" filled dense :label="$t('filters.sortBy')" hide-details :items="filteredHeaders">
                        <template v-slot:item="data">
                            <span>{{ $t(data.item.text) }}</span>
                        </template>
                        <template v-slot:selection="data">
                            <span>{{ $t(data.item.text) }}</span>
                        </template>                  
                    </v-select>
                </v-col> -->
                <!-- // * STATUS AND BUTTONS -->
                <v-col cols="12" class="pl-2 pr-0 d-flex align-center">
                    <!-- // * STATUS FILTER -->
                    <div>
                        <v-btn-toggle v-model="filter.status" multiple color="white" active-class="white" background-color="lightgrey" dense>
                            <v-btn value="APPROVED"
                                ><v-icon class="success--text icons8-checkmark-yes"></v-icon
                                ><span class="success--text caption hidden-sm-and-down">{{ $t(`status.approved`) }}</span></v-btn
                            >
                            <v-btn value="REJECTED"
                                ><v-icon class="warning--text text--lighten-1 icons8-high-importance"></v-icon
                                ><span class="warning--text caption hidden-sm-and-down">{{ $t(`status.rejected`) }}</span></v-btn
                            >
                            <v-btn value="PENDING"
                                ><v-icon class="grey--text text--lighten-1 icons8-circle"></v-icon
                                ><span class="grey--text caption hidden-sm-and-down">{{ $t(`status.pending`) }}</span></v-btn
                            >
                            <v-btn value="SUSPENDED"
                                ><v-icon class="error--text text--lighten-1  icons8-private"></v-icon
                                ><span class="error--text caption hidden-sm-and-down">{{ $t(`status.suspended`) }}</span></v-btn
                            >
                        </v-btn-toggle>
                    </div>
                    <!-- // * SHOW DELETED -->
                    <div class="d-flex" v-if="$vuetify.breakpoint.mdAndUp">
                        <v-icon class="ml-4 purple--text text-h4">icons8-trash</v-icon>
                        <v-switch @change="getTableData()" v-model="showDeleted" class="ml-1 purple--text" inset color="purple"></v-switch>
                    </div>
                    <v-spacer></v-spacer>
                    <!-- // * BUTTONS -->
                    <!-- <div><appbutton :label="$t(`buttons.add`)" icon="icons8-note" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" @click.native="openItem('', 'New', false)" /></div> -->
                    <div v-if="$vuetify.breakpoint.mdAndUp">
                        <appbutton
                            :label="$t(`buttons.columns`)"
                            icon="icons8-select-column"
                            type="secondary"
                            iconclass="white--text"
                            labelclass="white--text"
                            showlabel="2xlOnly"
                            @click.native="columnsDialog = true"
                        />
                    </div>
                    <div v-if="$vuetify.breakpoint.mdAndUp">
                        <appbutton
                            :label="$t(`buttons.export`)"
                            class="mr-1"
                            icon="icons8-export-csv"
                            type="secondary"
                            iconclass="white--text"
                            labelclass="white--text"
                            showlabel="2xlOnly"
                            @click.native="mix_exportDocuments(headersCSV, 'Users', formatExport)"
                        />
                    </div>
                </v-col>
                <!-- // * TABLE -->
                <v-col class="px-2 tabledata" v-if="$vuetify.breakpoint.mdAndUp" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-data-table
                        :headers="filteredHeaders"
                        :items-per-page="MIX_itemsPerPage(MIX_breakpoint())"
                        :items="computedTableData"
                        item-key="id"
                        class="elevation-0"
                        hide-default-header
                        :search="search"
                    >
                        <!-- // HEADERS -->
                        <template v-slot:header="{ props }">
                            <th
                                :align="head.align"
                                class="pa-4 px-2 font-weight-medium"
                                style="font-size:12px !important;"
                                v-for="(head, index) in props.headers"
                                :key="index"
                            >
                                {{ $t(`fields.${head.text}`) }}
                            </th>
                        </template>
                        <!-- // STATUS -->
                        <template v-slot:[`item.userStatus`]="{ item }">
                            <v-icon
                                v-if="item.userStatus === 'APPROVED'"
                                :style="{ 'background-image': 'url(' + require('@/assets/circle.svg') + ')' }"
                                class="iconbackground display-1 success--text icons8-checkmark-yes"
                            ></v-icon>
                            <v-icon
                                v-if="item.userStatus === 'REJECTED'"
                                :style="{ 'background-image': 'url(' + require('@/assets/circle.svg') + ')' }"
                                class="iconbackground display-1 warning--text icons8-high-importance"
                            ></v-icon>
                            <v-icon
                                v-if="item.userStatus === 'PENDING'"
                                :style="{ 'background-image': 'url(' + require('@/assets/circle.svg') + ')' }"
                                class="iconbackground display-1 grey--text icons8-circle"
                            ></v-icon>
                            <v-icon
                                v-if="item.userStatus === 'SUSPENDED'"
                                :style="{ 'background-image': 'url(' + require('@/assets/circle.svg') + ')' }"
                                class="iconbackground display-1 error--text icons8-private"
                            ></v-icon>
                        </template>
                        <!-- // NAME -->
                        <template v-slot:[`item.userName`]="{ item }">
                            <span
                                v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined"
                                class="error--text d-inline-block text-truncate"
                                style="max-width: 200px;"
                                ><v-icon class="error--text">icons8-trash</v-icon> {{ item.userName }}</span
                            >
                            <span v-else class="d-inline-block text-truncate text-capitalize" style="max-width: 200px;">{{ item.userName }}</span>
                        </template>
                        <!-- // EMAIL WITH LINK -->
                        <template v-slot:[`item.userEmail`]="{ item }">
                            <span class="d-inline-block text-truncate" style="max-width: 200px;"
                                ><a class="grey--text text--darken-4 text-decoration-none" :href="'mailto:' + item.userEmail">
                                    <v-icon>icons8-new-post</v-icon> {{ item.userEmail }}</a
                                ></span
                            >
                        </template>
                        <!-- // ORGANISATION -->
                        <template v-slot:[`item.organisation`]="{ item }">
                            <span class="d-inline-block text-truncate" style="max-width: 200px;">{{ item.organisation.organisationName }}</span>
                            <span
                                class="d-inline-block text-truncate pl-2"
                                style="max-width: 200px;"
                                v-if="item.site !== '' && item.site !== null && item.site !== undefined"
                            >
                                <span
                                    v-if="
                                        item.site.siteId !== '' &&
                                            item.site.siteId !== null &&
                                            item.site.siteId !== undefined &&
                                            item.organisation.organisationId === 'UshqEqj4OeCGI4JHMjUk'
                                    "
                                >
                                    ({{ item.site.siteName }})</span
                                >
                            </span>
                        </template>
                        <!-- // SPONSOR -->
                        <template v-slot:[`item.sponsor`]="{ item }">
                            <div
                                v-if="item.sponsor && item.sponsor.userName !== '' && item.sponsor.userName !== undefined && item.sponsor.userName !== null"
                                @click="MIX_popupUser(item.sponsor && item.sponsor.userId)"
                                class="pointer noselect fixedcolumn"
                            >
                                <v-icon>icons8-identification-documents</v-icon>
                                {{ item.sponsor.userName }}
                            </div>
                        </template>
                        <!-- // InductionDate -->
                        <!-- <template v-slot:[`item.inductionStatus`]="{ item }">
                            <span v-if="item.inductionStatus === 'REQUIRED'" class="error--text font-weight-bold">Required</span>
                            <span v-if="item.inductionStatus === 'VALID'" class="success--text font-weight-bold">Valid</span>
                            <span v-if="item.inductionStatus === 'EXPIRED'" class="error--text font-weight-bold">Expired</span>
                            <span v-if="item.inductionStatus === 'DUE'" class="warning--text font-weight-bold">Due</span>
                        </template>                         -->
                        <!-- // validInduction -->
                        <template v-slot:[`item.validInduction`]="{ item }">
                            <div v-if="item.validInduction.length > 0" class="pt-1">
                                <v-chip v-for="(item, index) in item.validInduction" :key="index" class="success mr-1 mb-1" small>{{
                                    item.siteName
                                }}</v-chip>
                            </div>
                        </template>
                        <template v-slot:[`item.dueInduction`]="{ item }">
                            <div v-if="item.dueInduction.length > 0" class="pt-1">
                                <v-chip v-for="(item, index) in item.dueInduction" :key="index" class="warning mr-1 mb-1" small>{{
                                    item.siteName
                                }}</v-chip>
                            </div>
                        </template>
                        <!-- // expiredInduction -->
                        <template v-slot:[`item.expiredInduction`]="{ item }">
                            <div v-if="item.expiredInduction.length > 0" class="pt-1">
                                <v-chip v-for="(item, index) in item.expiredInduction" :key="index" class="error mr-1 mb-1" small>{{
                                    item.siteName
                                }}</v-chip>
                            </div>
                        </template>
                        <!-- // requiredInduction -->
                        <template v-slot:[`item.requiredInduction`]="{ item }">
                            <div v-if="item.requiredInduction.length > 0" class="pt-1">
                                <v-chip v-for="(item, index) in item.requiredInduction" :key="index" class="error mr-1 mb-1" small>{{
                                    item.siteName
                                }}</v-chip>
                            </div>
                        </template>
                        <!-- // ACTION -->
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-btn @click="openItem(item.id, 'View', false)" depressed class="black--text white"
                                >Open<v-icon>mdi-chevron-right</v-icon></v-btn
                            >
                        </template>
                        <!-- // SWAPP STATUS-->
                        <template v-slot:[`item.swappStatus`]="{ item }">
                            <v-chip class="success" small v-if="item.swappStatus === 1">IN</v-chip>
                            <v-chip class="lightgrey" small v-else>OUT</v-chip>
                        </template>
                        <!-- // CREATED USER DATA -->
                        <template v-slot:[`item.createdUserData`]="{ item }">
                            <div
                                v-if="item.createdUserData !== '' && item.createdUserData !== undefined && item.createdUserData !== null"
                                @click="MIX_popupUser(item.createdUserData.userId)"
                                class="pointer noselect fixedcolumn"
                            >
                                <v-icon>icons8-identification-documents</v-icon>
                                {{ item.createdUserData.userName }}
                            </div>
                        </template>
                        <!-- // MODIFIED USER DATA -->
                        <template v-slot:[`item.modifiedUserData`]="{ item }">
                            <div
                                v-if="item.modifiedUserData !== '' && item.modifiedUserData !== undefined && item.modifiedUserData !== null"
                                @click="MIX_popupUser(item.modifiedUserData.userId)"
                                class="pointer noselect fixedcolumn"
                            >
                                <v-icon>icons8-identification-documents</v-icon>
                                {{ item.createdUserData.userName }}
                            </div>
                        </template>
                        <!-- // DELETE USER DATA -->
                        <template v-slot:[`item.deleteUserData`]="{ item }">
                            <div
                                v-if="item.deleteUserData !== '' && item.deleteUserData !== undefined && item.deleteUserData !== null"
                                @click="MIX_popupUser(item.deleteUserData.userId)"
                                class="pointer noselect fixedcolumn"
                            >
                                <v-icon>icons8-identification-documents</v-icon>
                                {{ item.deleteUserData.userName }}
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
                <!-- // * MOBILE CARDS / Instead of Table -->
                <v-col class="px-2 tabledata" v-if="$vuetify.breakpoint.smAndDown" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-row no-gutters>
                        <v-col
                            cols="12"
                            xs="12"
                            class="my-1 pa-1 white tablecard"
                            v-for="item in computedTableData"
                            :key="item.id"
                            @click="openItem(item.id, 'View', false)"
                        >
                            <v-row class="d-flex align-center justify-center pa-3 fill-height" no-gutters>
                                <v-col cols="2" class="">
                                    <v-icon
                                        v-if="item.userStatus === 'APPROVED'"
                                        :style="{ 'background-image': 'url(' + require('@/assets/circle.svg') + ')' }"
                                        class="iconbackground display-1 success--text icons8-checkmark-yes"
                                    ></v-icon>
                                    <v-icon
                                        v-if="item.userStatus === 'REJECTED'"
                                        :style="{ 'background-image': 'url(' + require('@/assets/circle.svg') + ')' }"
                                        class="iconbackground display-1 warning--text icons8-high-importance"
                                    ></v-icon>
                                    <v-icon
                                        v-if="item.userStatus === 'PENDING'"
                                        :style="{ 'background-image': 'url(' + require('@/assets/circle.svg') + ')' }"
                                        class="iconbackground display-1 grey--text icons8-circle"
                                    ></v-icon>
                                    <v-icon
                                        v-if="item.userStatus === 'SUSPENDED'"
                                        :style="{ 'background-image': 'url(' + require('@/assets/circle.svg') + ')' }"
                                        class="iconbackground display-1 error--text icons8-private"
                                    ></v-icon>
                                </v-col>
                                <v-col cols="7" class="d-flex flex-column">
                                    <div style="margin: 0px !important; line-height: 20px !important;" class="noselect">
                                        <span class="d-inline-block text-truncate" style="max-width: 200px;">{{ item.userName }}</span>
                                    </div>
                                    <div style="" class="font-weight-bold caption grey--text text--darken-1 noselect">{{ item.userType }}</div>
                                </v-col>
                                <v-col cols="3" class="text-right"
                                    ><v-icon @click="openItem(item.id, 'View', false)" depressed class="black--text white"
                                        >mdi-chevron-right</v-icon
                                    ></v-col
                                >
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <!-- // * COPYRIGHT -->
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="px-0 copyright">
                    <appcopyright />
                </v-col>
            </v-row>
        </v-col>
        <!-- // * RIGHT PANEL -->
        <!-- // * DYNAMIC COMPONENT PANEL -->
        <transition
            name="custom-classes-transition"
            enter-active-class="animate__animated animate__fadeIn animate__faster"
            leave-active-class="animate__animated animate__fadeOut animate__faster"
            mode="out-in"
        >
            <rightpanel></rightpanel>
        </transition>
        <!-- // * DYNAMIC COMPONENT DIALOG -->
        <v-dialog v-model="columnsDialog" scrollable max-width="300px">
            <v-card>
                <v-card-title>{{ $t('miscHeadings.showHideColumns') }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px;">
                    <v-list>
                        <v-list-item v-for="(header, index) in columnHeaders" :key="index">
                            <v-list-item-title
                                ><v-checkbox
                                    color="grey darken-1"
                                    hide-details
                                    v-model="headers[index].hidden"
                                    :false-value="true"
                                    :true-value="false"
                                    :label="$t(`fields.${header.text}`)"
                                ></v-checkbox
                            ></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="text-right">
                    <v-spacer />
                    <v-btn color="primary" text @click="columnsDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex' // Map Actions / Getters
export default {
    // * DATA
    data: () => ({
        collection: 'users',
        collectionTitle: 'Users',
        collectionItem: 'user',
        collectionItemTitle: 'User',
        langPath: 'users',
        columnsDialog: false,
        search: '', // Table Search
        sortBy: 'userName', // Default Table Sort By
        customWhere: [],
        filter: {
            // Default Filters
            sortAsc: true,
            status: ['APPROVED', 'PENDING', 'REJECTED', 'SUSPENDED'],
            type: '',
            roles: '',
            organisation: null,
            site: '',
            complianceNotifications: false
        },
        tableData: [], // Table Data
        headers: [
            // Table Headers
            // hidden shows the initial value of the column - hidden or visible
            // hides determines if you want to hide the column on screen resize
            { text: 'status', value: 'userStatus', sortable: false, align: 'center', hidden: false, hide: false },
            { text: 'id', value: 'id', sortable: false, align: 'start', hidden: true, hide: false },
            { text: 'name', value: 'userName', align: 'start', sortable: false, hidden: false, hide: false },
            { text: 'jobTitle', value: 'userJobTitle', sortable: false, align: 'start', hidden: false, hide: true },
            { text: 'organisation', value: 'organisation', sortable: false, align: 'start', hidden: false, hide: false },

            { text: 'email', value: 'userEmail', sortable: false, align: 'start', hidden: false, hide: false },
            { text: 'telephone', value: 'userTelephone', sortable: false, align: 'start', hidden: false, hide: true },
            // { text: 'subContractorName', value: 'subContractorName', sortable: false, align: 'start', hidden: false, hide: false },
            { text: 'sponsor', value: 'sponsor', sortable: false, align: 'start', hidden: false, hide: false },
            { text: 'userType', value: 'userType', sortable: false, align: 'start', hidden: true, hide: false },
            { text: 'userRole', value: 'userRole', sortable: false, align: 'start', hidden: true, hide: false },
            { text: 'swappStatus', value: 'swappStatus', sortable: false, align: 'center', hidden: false, hide: true },
            { text: 'lastSite', value: 'lastSite', sortable: false, align: 'start', hidden: true, hide: true },
            { text: 'lastLocation', value: 'lastLocation', sortable: false, align: 'start', hidden: true, hide: true },
            { text: 'description', value: 'description', sortable: false, align: 'start', hidden: true, hide: false },
            // { text: 'inductionStatus', value: 'inductionStatus', sortable: false, align: 'start', hidden: false, hide: true },
            { text: 'validInduction', value: 'validInduction', sortable: false, align: 'start', hidden: false, hide: true },
            { text: 'dueInduction', value: 'dueInduction', sortable: false, align: 'start', hidden: false, hide: true },
            { text: 'expiredInduction', value: 'expiredInduction', sortable: false, align: 'start', hidden: false, hide: true },
            { text: 'requiredInduction', value: 'requiredInduction', sortable: false, align: 'start', hidden: false, hide: true },
            { text: 'created', value: 'createdDateTime', sortable: false, align: 'start', align: 'start', hidden: true, hide: false },
            { text: 'createdUserData', value: 'createdUserData', sortable: false, align: 'start', align: 'start', hidden: true, hide: false },
            { text: 'modified', value: 'modifiedDateTime', sortable: false, align: 'start', align: 'start', hidden: true, hide: false },
            { text: 'modifiedUserData', value: 'modifiedUserData', sortable: false, align: 'start', align: 'start', hidden: true, hide: false },
            { text: 'delete', value: 'delete', align: 'left', sortable: false, align: 'start', align: 'start', hidden: true, hide: false },
            { text: 'deleteUserData', value: 'deleteUserData', sortable: false, align: 'start', align: 'start', hidden: true, hide: false },
            { text: 'actions', value: 'actions', align: 'right', sortable: false, sortable: false, hidden: false, hide: false }
        ],
        headersCSV: {
            userStatus: 'Status',
            id: 'ID',
            userName: 'Name',
            userEmail: 'Email',
            userTelephone: 'Telephone',
            organisation: 'Organisation',
            userType: 'Type',
            userRole: 'Role',
            userJobTitle: 'Job Title',
            swappStatus: 'SWAPP Status',
            lastSite: 'Last Site',
            lastLocation: 'Last Location',
            validInduction: 'Valid Inductions',
            dueInduction: 'Due Inductions',
            expiredInduction: 'Expired Inductions',
            requiredInduction: 'Required Inductions',
            createdDateTime: 'Created Date and Time',
            createdUserData: 'Created By',
            modifiedDateTime: 'Modified Date and Time',
            modifiedUserData: 'Modified By'
        },
        // EXPORT
        exportData: [],
        // LOOKUP VALUES
        userTypes: [], // USER TYPES
        userRoles: [], // USER ROLES
        contactTypes: [], // CONTACT TYPES
        sites: [], // SITES
        organisations: [], // ORGANISATIONS
        showDeleted: false, // SHOW DELETED
        filteredHeaders: []
    }),
    // * COMPUTED
    computed: {
        // Map Getters
        ...mapGetters({
            GET_panelLayout: 'GET_panelLayout',
            GET_lookupValues: 'GET_lookupValues',
            GET_help: 'GET_help',
            GET_organisations: 'GET_organisations',
            GET_sites: 'GET_sites'
        }),
        // Build each row with the same keys, in the same order, as headersCSV - mix_exportDocuments writes values by position
        formatExport() {
            const t = this
            const usersById = {}
            t.tableData.forEach(user => {
                usersById[user.id] = user
            })
            const csvValue = value => '"' + String(value === undefined || value === null ? '' : value).replace(/"/g, '""') + '"'
            // Site names, with the expiry date (2 years from induction) when there is one
            const inductionList = inductions =>
                inductions
                    .map(induction => {
                        const inductionDate = induction.date || induction.inductionDate
                        if (!inductionDate) return induction.siteName
                        const expiry = t
                            .$moment(inductionDate, 'x')
                            .add(2, 'years')
                            .format('DD-MMM-YYYY')
                        return induction.siteName + ' (expires ' + expiry + ')'
                    })
                    .join('; ')

            t.exportData = t.computedTableData.map(item => {
                const user = usersById[item.id] || {}
                const row = {
                    userStatus: item.userStatus,
                    id: item.id,
                    userName: item.userName,
                    userEmail: item.userEmail,
                    userTelephone: item.userTelephone,
                    organisation: item.organisation ? item.organisation.organisationName : '',
                    userType: item.userType,
                    userRole: item.userRole,
                    userJobTitle: item.userJobTitle,
                    swappStatus: parseInt(item.swappStatus) === 1 ? 'IN' : 'OUT',
                    lastSite: item.lastSite,
                    lastLocation: item.lastLocation,
                    validInduction: inductionList(item.validInduction),
                    dueInduction: inductionList(item.dueInduction),
                    expiredInduction: inductionList(item.expiredInduction),
                    requiredInduction: inductionList(item.requiredInduction),
                    createdDateTime: t.MIX_formatDateTime(user.createdDateTime, 'x', 'DD-MMM-YYYY HH:mm'),
                    createdUserData: user.createdUserData ? user.createdUserData.userName : '',
                    modifiedDateTime: t.MIX_formatDateTime(user.modifiedDateTime, 'x', 'DD-MMM-YYYY HH:mm'),
                    modifiedUserData: user.modifiedUserData ? user.modifiedUserData.userName : ''
                }
                Object.keys(row).forEach(key => {
                    row[key] = csvValue(row[key])
                })
                return row
            })
            return t.exportData
        },
        // Computed Table Headers
        // computedHeaders() {
        //     var t = this;
        //     var headers = t.headers;
        //     return (t.$filter(headers, {
        //         hidden: false, // filter headers based on initial hidden value
        //     }));
        // },
        // Remove actions from Selectable Column Headers
        columnHeaders() {
            var t = this
            var headers = t.headers
            return headers.filter(header => {
                return header.value !== 'actions'
            })
        },
        // Computed Cols
        computedCols() {
            var t = this
            var cols
            var leftPanel = t.GET_panelLayout.leftPanel
            switch (true) {
                case leftPanel === 12:
                    cols = 6
                    break
                case leftPanel === 6:
                    cols = 12
                    break
                default:
                    cols = 12
            }
            if (t.$vuetify.breakpoint.smAndDown) {
                cols = 12
            }
            return cols
        },
        // Computed Table Data
        computedTableData() {
            var t = this
            var tableData = t.tableData

            // Filter by status
            tableData = tableData.filter(function(item) {
                return t.filter.status.includes(item[t.collectionItem + 'Status'])
            })
            // Filter by type
            if (t.filter.type !== '' && t.filter.type !== undefined && t.filter.type !== null) {
                tableData = tableData.filter(function(item) {
                    return t.filter.type === item[t.collectionItem + 'Type']
                })
            }
            // Filter by Roles
            if (t.filter.roles !== '' && t.filter.roles !== undefined && t.filter.roles !== null) {
                tableData = tableData.filter(function(item) {
                    return t.filter.roles === item[t.collectionItem + 'Role']
                })
            }
            // Filter by Search Mobile
            if (t.search !== '' && t.$vuetify.breakpoint.smAndDown) {
                tableData = tableData.filter(function(item) {
                    var itemName = item[t.collectionItem + 'Name'].toUpperCase()
                    var search = t.search.toUpperCase()
                    return itemName.includes(search)
                })
            }
            // Filter by Organisation (CUSTOM)
            if (t.filter.organisation !== '' && t.filter.organisation !== undefined && t.filter.organisation !== null) {
                tableData = tableData.filter(function(item) {
                    return item.organisation && item.organisation.organisationId === t.filter.organisation.organisationId
                })
            }
            // Filter by Site
            if (t.filter.site !== '' && t.filter.site !== undefined && t.filter.site !== null) {
                tableData = tableData.filter(function(item) {
                    return t.filter.site.siteId === item.lastSite.siteId || t.filter.site.siteId === item.lastSite.id
                })
            }
            // Filter by Compliance Notifications
            if (t.filter.complianceNotifications) {
                tableData = tableData.filter(function(item) {
                    return item && item.isTaffsWellAdminUser === true
                })
            }
            // get inductions
            for (var i = 0; i < tableData.length; i++) {
                var item = tableData[i]
                item.computedInduction = t.calculateInduction(item.inductions, item)
            }
            var tableDataList = tableData.map(e => {
                return {
                    userStatus: e.userStatus,
                    id: e.id,
                    userName: e.userName,
                    userJobTitle: e.userJobTitle,
                    organisation: e.organisation,
                    userEmail: e.userEmail,
                    userTelephone: e.userTelephone,
                    sponsor: e.host,
                    site: e.site,
                    inductionStatus: this.calculateInductionDate(e.inductionDate),
                    validInduction: e.computedInduction.valid,
                    dueInduction: e.computedInduction.due,
                    expiredInduction: e.computedInduction.expired,
                    requiredInduction: e.computedInduction.required,
                    userType: e.userType,
                    userRole: e.userRole,
                    lastSite: e.lastSite ? e.lastSite.siteName : '',
                    subContractorName: e.subContractorName,
                    lastLocation: e.lastLocation ? e.lastLocation.locationName : '',
                    swappStatus: e.swappStatus,
                    isTaffsWellAdminUser: e.isTaffsWellAdminUser,
                    // createdDateTime: t.MIX_formatDateTime(e.createdDateTime, 'x', 'DD-MMM-YY HH:mm'),
                    // createdUserData: e.createdUserData,
                    // modifiedDateTime: t.MIX_formatDateTime(e.modifiedDateTime, 'x', 'DD-MMM-YY HH:mm'),
                    // modifiedUserData: e.modifiedUserData,
                    delete: t.MIX_formatDateTime(e.delete, 'x', 'DD-MMM-YY HH:mm'),
                    deleteUserData: e.deleteUserData
                }
            })
            // Sort the Table by the Field in the Sort By Filter
            var sortResults = t.$sortBy(tableDataList, t.sortBy)
            if (!t.filter.sortAsc) {
                sortResults.reverse()
            }
            return sortResults
        }
    },
    // * WATCH
    watch: {
        GET_currentUser: {
            handler() {
                this.getTableData()
            },
            deep: true
        },
        GET_panelLayout: {
            handler() {
                let t = this
                if (t.GET_panelLayout.rightPanel === 6) {
                    t.filteredHeaders = t.headers.filter(header => {
                        return header.hide === false && header.hidden === false
                    })
                } else {
                    t.filteredHeaders = t.headers.filter(header => {
                        return header.hidden === false
                    })
                }
            },
            deep: true
        },
        headers: {
            handler() {
                let t = this
                t.filteredHeaders = t.headers.filter(header => {
                    return header.hidden === false
                })
            },
            deep: true
        }
    },
    // * METHODS
    methods: {
        ...mapActions({ ACT_openItem: 'ACT_openUser' }),
        // UPDATE BREADCRUMBS
        updateBreadcrumbs() {
            var t = this
            var breadcrumbs = []
            breadcrumbs.push({ name: `${t.collectionTitle}`, path: `/${t.collection}` }) // Set the Main Path
            t.MIX_breadcrumbs(breadcrumbs)
        },
        // OPEN ITEM
        openItem: async function(id, process, popup) {
            var t = this
            var item = {}
            t.dynamicComponentKey++
            item.process = process
            item.popup = popup
            if (item.process !== 'New') {
                var itemResult = await t.MIX_readDocumentById(t.collection, id)
                item.data = itemResult.data
            } else {
                item.data = null
            }
            t.ACT_openItem(item) // Open Item
            if (t.$vuetify.breakpoint.lgAndDown) {
                t.MIX_fsDialog(true, t.collectionItemTitle, t.collectionItem)
                t.MIX_setPanelLayout(12, 0, false, '')
            } else {
                t.MIX_setPanelLayout(6, 6, true, t.collectionItemTitle, t.collectionItem)
                // // * HIDE HEADERS
                // for (var i = 0; i < t.headers.length; i++) {
                //     if (t.headers[i].hide === true) {
                //         t.headers[i].hidden = true;
                //     }
                // }
            }
            return
        },
        // REMOVE UPLOADED DOCUMENT
        removeUploadedDocument() {
            this.$store.commit('upload_file_store/setFile', null)
        },
        // GET NOTICES SNAPSHOT METHOD
        getTableData: async function() {
            var t = this
            var collection = t.$firebase.db.collection(t.collection)
            t.customWhere = []
            switch (true) {
                case t.GET_currentUser.userType === 'CONTRACTOR' || t.GET_currentUser.userType === 'VISITOR':
                    t.customWhere.push({ key: 'organisation.organisationId', operator: '==', value: t.GET_currentUser.organisation.organisationId })
                    break
                default:
            }

            if (JSON.stringify(t.customWhere) !== '[]') {
                for (var i = 0; i < t.customWhere.length; i++) {
                    var query = { field: t.customWhere[i].key, operator: t.customWhere[i].operator, value: t.customWhere[i].value }
                    collection = collection.where(query.field, query.operator, query.value)
                }
            }
            collection.onSnapshot(function(querySnapshot) {
                t.tableData = []
                querySnapshot.forEach(function(doc) {
                    var document = doc.data()
                    document.id = doc.id
                    if (!document.hasOwnProperty('delete')) {
                        t.tableData.push(document)
                    } else if (t.showDeleted) {
                        t.tableData.push(document)
                    } else {
                        // Do not Show Concern
                    }
                })
            })
            return
        },
        calculateInduction: function(inductions, user) {
            let t = this // Initialize arrays to store different induction categories
            var validInductions = []
            var requiredInductions = []
            var expiredInductions = []
            var dueInductions = []
            var currentDate = t.$moment().format('x')

            for (var i = 0; i < t.sites.length; i++) {
                var site = t.sites[i]
                var siteHasInduction = false

                // Check if inductions exist and is an array
                if (inductions && Array.isArray(inductions)) {
                    // Filter inductions for current site
                    var siteInductions = inductions.filter(function(induction) {
                        return induction.site === site.siteId
                    })
                    // get the latest siteInduction
                    siteInductions = t.$sortBy(siteInductions, 'date').reverse()
                    // Process latest site induction ONLY THE LASTEST ONE YOU FUCKER
                    siteInductions = siteInductions.slice(0, 1)
                    siteInductions.forEach(function(induction) {
                        siteHasInduction = true
                        induction.siteName = site.siteName

                        // Calculate induction expiry date (2 years from induction date)
                        var inductionDate2Y = t
                            .$moment(induction.date, 'x')
                            .add(2, 'years')
                            .format('x')
                        // Calculate days until/since expiry
                        var inductionDue = t.$moment(currentDate, 'x').diff(t.$moment(inductionDate2Y, 'x'), 'days')

                        // Categorize the induction
                        if (inductionDue > 0) {
                            // Induction expired
                            expiredInductions.push(induction)
                        } else if (inductionDue > -90 && inductionDue <= 0) {
                            // Required induction (within 90 days of expiry)
                            dueInductions.push(induction)
                        } else {
                            // Valid induction (more than 90 days until expiry)
                            validInductions.push(induction)
                        }
                    })
                }

                // if user has inductionDate, set it to canton site

                if (site.siteId == 'aeKJ3GotwdOBVoA1f2oY' && !siteHasInduction) {
                    // check users inductionDate field
                    var userInduction = user.inductionDate
                    // check if valid - users registered since the per-site inductions have no inductionDate at all
                    if (userInduction && userInduction !== '') {
                        var inductionStatus = t.calculateInductionDate(userInduction)
                        if (inductionStatus === 'VALID') {
                            validInductions.push({
                                siteId: site.siteId,
                                siteName: site.siteName,
                                inductionDate: userInduction,
                                status: 'valid'
                            })
                        } else if (inductionStatus === 'EXPIRED') {
                            expiredInductions.push({
                                siteId: site.siteId,
                                siteName: site.siteName,
                                inductionDate: userInduction,
                                status: 'expired'
                            })
                        } else if (inductionStatus === 'DUE') {
                            dueInductions.push({
                                siteId: site.siteId,
                                siteName: site.siteName,
                                inductionDate: userInduction,
                                status: 'due'
                            })
                        }
                        siteHasInduction = true
                    }
                }

                // If site has no inductions, add it to required inductions
                if (!siteHasInduction) {
                    requiredInductions.push({
                        siteId: site.siteId,
                        siteName: site.siteName,
                        inductionDate: null,
                        status: 'required'
                    })
                }
            }

            // Return all categorized inductions
            return {
                valid: validInductions,
                required: requiredInductions,
                expired: expiredInductions,
                due: dueInductions
            }
        },
        calculateInductionDate: function(date) {
            let t = this
            var inductionStatus
            if (date !== '') {
                var inductionDate2Y = t
                    .$moment(date, 'x')
                    .add(2, 'years')
                    .format('x')
                var currentDate = t.$moment().format('x')
                var inductionDue = t.$moment(currentDate, 'x').diff(t.$moment(inductionDate2Y, 'x'), 'days')
                //var inductionRenewal = inductionDate2Y;
                switch (true) {
                    case inductionDue > 0:
                        inductionStatus = 'EXPIRED'
                        break
                    case inductionDue > -90 && inductionDue < 0:
                        inductionStatus = 'DUE'
                        break
                    default:
                        inductionStatus = 'VALID'
                        break
                }
            } else {
                inductionStatus = 'REQUIRED'
            }
            return inductionStatus
        }
    },
    // * MOUNTED
    async mounted() {
        // * DEFAULT MOUNTED
        var t = this
        t.MIX_setPanelLayout(12, 0, false, '') // Hide Right Panel
        t.updateBreadcrumbs() // Update Breadcrumbs in Title
        // INSERT CUSTOM WHERES HERE
        // t.customWhere.push ({ key: '', operator: '==', value: '' });
        t.getTableData() // Get Table Data
        // * LOOKUP RELATED MOUNTED
        // LOOKUPS
        await t.MIX_lookupValues() // LOAD LOOKUP VALUES
        t.userTypes = await t.GET_lookupValues('USERTYPES')
        t.userRoles = await t.GET_lookupValues('USERROLES')
        t.contactTypes = await t.GET_lookupValues('CONTACTTYPES')
        // GET SITES
        await t.MIX_sites() // UPDATE SITES LIST IN STORE (id, siteName)
        t.sites = t.$sortBy(t.GET_sites, 'siteName') // STORE SITES IN LOCAL ARRAY
        // GET ORGANISATIONS
        await t.MIX_organisations() // UPDATE SITES LIST IN STORE (id, siteName)
        t.organisations = t.$sortBy(t.GET_organisations, 'organisationName') // STORE SITES IN LOCAL ARRAY

        // * AUTO OPEN SITE IF PATH CONTAINS SITEID
        if (window.location.pathname !== `/${t.collection}` && window.location.pathname !== `/${t.collection}/`) {
            var urlPath = window.location.pathname.split('/')
            var id = urlPath[2]
            t.openItem(id, 'View', false)
        }
    }
}
</script>

<style>
/* .border-bottom-red { background-color: white; border-bottom: 2px solid var(--v-primary-base) !important; }
    .bottom { position: fixed; bottom: 30px; } */
</style>
